<script setup lang="ts">
import Pc from './components/pc.vue'
import Mobile from './components/mobile.vue'
import { useScreenStore } from '@/store/screen'

const screenStore = useScreenStore()

</script>

<template>
  <Pc v-if="screenStore.screen === 'pc'" />
  <Mobile v-else />
</template>

<style lang="scss" scoped></style>
